'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcTextareaAutogrow
* @element TEXTAREA
* @description
* # tcTextareaAutogrow
* Logic for auto growing textarea elements based on the amount of text entered
*/
angular.module('tcApp')
.directive('tcTextareaAutogrow', function($timeout, $mdUtil, $log, tcConstants, GlobalService) {
	return {
		restrict: 'A',
		scope: false,
		link: function(scope, element, attrs) {
			var maxLines = (Object.prototype.hasOwnProperty.call(attrs, 'tcTextareaAutogrowMaxLines') ?
							parseInt(attrs.tcTextareaAutogrowMaxLines) : 20);
			var minLines = (Object.prototype.hasOwnProperty.call(attrs, 'tcTextareaAutogrowMinLines') ?
							parseInt(attrs.tcTextareaAutogrowMinLines) : 5);
			var textareaElement = element[0];
			var hiddenChangeWatcherUnbind;
			// Find the scrollable container starting from the parent
			var scrollParent = GlobalService.getScrollableParent(element.parent()[0]);
			
			$timeout(function() {
				$mdUtil.nextTick(growTextarea);
			}, 10, false);
			
			var setupTextarea = function() {
				if (GlobalService.isTouchDevice()) {
					element.attr('autocorrect', 'on');
					element.attr('autocapitalize', 'sentences');
				}
			};
			setupTextarea();
			
			var growTextarea = function() {
				// Preserve the scroll coordinates of the scrollable container
				var scrollTop = (scrollParent ? scrollParent.scrollTop : null);
				var scrollLeft = (scrollParent ? scrollParent.scrollLeft : null);

				element.css('height', 'auto');
				var lineHeight = GlobalService.getLineHeight();
				var height = getHeight();
				
				height = Math.max(height, lineHeight * minLines);
				var maxHeight = (lineHeight * maxLines);
				if (maxHeight < height) {
					height = maxHeight;
				}
				
				element.css('height', height + 'px');
				if (scrollParent) {
					// Reset the scroll coordinates - primarily for Chrome
					scrollParent.scrollTo(scrollLeft, scrollTop);
				}
			};
			
			var getHeight = function() {
				var offsetHeight = textareaElement.offsetHeight;
				var line = (textareaElement.scrollHeight - offsetHeight);
				return (offsetHeight + Math.max(line, 0));
			};
			
			// Trigger the resize on Enter, Cut or Paste
			var textareaEventHandler = function($event) {
				if ((['cut','paste'].indexOf($event.type) !== -1)
					|| ($event.keyCode === tcConstants.KEY_CODE.ENTER)) {
					$mdUtil.nextTick(growTextarea);
				}
			};
	
			// For textareas that are initially hidden,
			// attach a watcher to detect when the textarea gets shown
			var handleHiddenChange = function() {
				var wasHidden = false;
				return function handleHiddenChangeWatcher() {
					var isHidden = (textareaElement.offsetHeight === 0);
					if ((isHidden === false) && (wasHidden === true)) {
						growTextarea();
					}
					wasHidden = isHidden;
					// Runs often and causes layout recalculation, so unattach once it is first shown
					if ((!isHidden) && (angular.isDefined(hiddenChangeWatcherUnbind))) {
						hiddenChangeWatcherUnbind();
					}
				};
			}();

			// Check every digest cycle whether the visibility of the textarea has changed.
			// Queue up to run after the digest cycle is complete.
			hiddenChangeWatcherUnbind = scope.$watch(function hiddenChangeWatcher() {
				$mdUtil.nextTick(handleHiddenChange, false);
				return true;
			});
			
			element.on('keydown cut paste', textareaEventHandler);
			
			// Resize the text area on canned text insert
			scope.$on('tcLookupContainer:rowSelected', function handleLookupSelected($event, lookupId) {
				if (lookupId === scope.$parent.lookupId) {
					$mdUtil.nextTick(growTextarea);
				}
			});
			
			scope.$on('$destroy', function() {
				element.off('keydown cut paste', textareaEventHandler);
			});
		}
	};
});
